(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/net-sales.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/net-sales.js');
"use strict";

const {
  CurrencyFromJupiterString
} = svs.utils.format;
const {
  CurrencyCounter
} = svs.components.lbUi.currencyCounter;
const NetSales = _ref => {
  let {
    currencyCounterUniqueId,
    currentNetSale,
    drawIsCancelled
  } = _ref;
  const netSales = CurrencyFromJupiterString(currentNetSale);
  if (netSales === 0) {
    return null;
  }
  return React.createElement("div", {
    className: "result-net-sales f-550 ".concat(drawIsCancelled && 'result-net-sales-cancelled')
  }, React.createElement("span", null, "Oms\xE4ttning: ", React.createElement(CurrencyCounter, {
    amount: currentNetSale,
    uniqueId: currencyCounterUniqueId
  }), " kr"), drawIsCancelled && React.createElement("span", {
    className: "result-net-sales-cancelled--text f-700"
  }, "\xC5terbetalas"));
};
setGlobal('svs.components.tipsen.routeResult.NetSales', NetSales);

 })(window);